import {
    SET_IS_MOBILE, SET_IS_LOADING, SET_IS_ERROR, SET_HAS_NAVIGATE, SET_SERVICE_IS_DOWN, SET_IS_SCREEN_UNDER_600_PIXEL, SET_IS_SCREEN_UNDER_768_PIXEL,
    SET_APPLICATION_FLOW_TYPE
} from '../actions';

export function serviceIsDown(prevState = false, action : any = {}) {
    switch (action.type) {
        case SET_SERVICE_IS_DOWN: {
            return action.value;
        }
        default: {
            return prevState;
        }
    }
}

export function isLoading(prevState = false, action : any = {}) {
    switch (action.type) {
        case SET_IS_LOADING: {
            return action.value;
        }
        default: {
            return prevState;
        }
    }
}
export function isError(prevState = false, action : any = {}) {
    switch (action.type) {
        case SET_IS_ERROR: {
            return action.value;
        }
        default: {
            return prevState;
        }
    }
}

export function hasNavigate(prevState : any = {}, action : any = {}) {
    switch (action.type) {
        case SET_HAS_NAVIGATE: {
            return action.value;
        }
        default: {
            return prevState;
        }
    }
}

export function isMobile(prevState = false, action : any = {}) {
    switch (action.type) {
        case SET_IS_MOBILE: {
            return action.value;
        }
        default: {
            return prevState;
        }
    }
}

export function isScreenWidthUnder600Pixel(prevState = false, action : any = {}) {
    switch (action.type) {
        case SET_IS_SCREEN_UNDER_600_PIXEL: {
            return action.value;
        }
        default: {
            return prevState;
        }
    }
}

export function isScreenWidthUnder768Pixel(prevState = false, action : any = {}) {
    switch (action.type) {
        case SET_IS_SCREEN_UNDER_768_PIXEL: {
            return action.value;
        }
        default: {
            return prevState;
        }
    }
}

export function applicationStateReducer(prevState : any = {}, action : any = {}) {
    switch (action.type) {
        case SET_APPLICATION_FLOW_TYPE: {
            return { ...prevState, ...action.value };
        }
        default: {
            return prevState;
        }
    }
}
